import React from 'react';
import Translation from '../../../../shared/Translation';
import { isListingMonetizationAEnabled } from '../../../../helpers/ABTesting';

export const ReservationTimer = ({ time, showTimeOnly = false }) => {
  return (
    <div className="cart-summary__timer">
      <span className="cart-summary__timer-icon">
        <i className="icon-schedule" aria-hidden="true">
          <span className="sr-only">Timer</span>
        </i>
      </span>
      <span className="cart-summary__timer-time" aria-live="polite">
        {showTimeOnly && time}
        {!showTimeOnly && (
          <Translation interpolation={{ boldStart: '<strong>', timeLeft: time, boldEnd: '</strong>' }}>
            {isListingMonetizationAEnabled() ? 'checkout__tickets_are_held_for' : 'checkout__timer'}
          </Translation>
        )}
      </span>
    </div>
  );
};
